module.exports = __webpack_public_path__ + "img/coinbasewallet@2x.28805e9a.png";